<div class="dropdown">
  <button class="btn btn-light dropdown-toggle btn-sm btn-services" type="button" data-bs-toggle="dropdown"
    data-bs-auto-close="true" aria-expanded="false" title="Acquisti">
    Acquisti
  </button>
  <ul class="dropdown-menu dropdown-menu-end px-2">
    <li>
      <button class="dropdown-item rounded rounded-1" type="button" title="Nuovo Acquisto"
        (click)="openPurchaseTraceDialog()">
        <i class="bi bi-receipt me-2"></i> Nuovo Acquisto
      </button>
    </li>
    <li>
      <button [routerLink]="PURCHASES_TRACES" class="dropdown-item rounded rounded-1" type="button"
        title="Acquisti Tracciati">
        <i class="bi bi-file-earmark-bar-graph me-2"></i> Acquisti Tracciati
      </button>
    </li>
  </ul>
</div>